{
  "name": "oidc-client-ts",
  "version": "3.1.0",
  "description": "OpenID Connect (OIDC) & OAuth2 client library",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/authts/oidc-client-ts.git"
  },
  "homepage": "https://github.com/authts/oidc-client-ts#readme",
  "license": "Apache-2.0",
  "main": "dist/umd/oidc-client-ts.js",
  "types": "dist/types/oidc-client-ts.d.ts",
  "exports": {
    ".": {
      "types": "./dist/types/oidc-client-ts.d.ts",
      "import": "./dist/esm/oidc-client-ts.js",
      "require": "./dist/umd/oidc-client-ts.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist"
  ],
  "keywords": [
    "authentication",
    "oauth2",
    "oidc",
    "openid",
    "OpenID Connect"
  ],
  "scripts": {
    "build": "node scripts/build.js && npm run build-types",
    "build-types": "tsc -p tsconfig.build.json && api-extractor run",
    "clean": "git clean -fdX dist lib *.tsbuildinfo",
    "prepack": "npm run build",
    "test": "tsc && jest",
    "typedoc": "typedoc",
    "lint": "eslint --max-warnings=0 --cache .",
    "prepare": "husky"
  },
  "dependencies": {
    "jwt-decode": "^4.0.0"
  },
  "devDependencies": {
    "@microsoft/api-extractor": "^7.47.2",
    "@testing-library/jest-dom": "^6.4.6",
    "@types/jest": "^29.5.12",
    "@types/node": "^22.4.1",
    "@typescript-eslint/eslint-plugin": "^7.16.1",
    "@typescript-eslint/parser": "^7.16.1",
    "esbuild": "^0.24.0",
    "eslint": "^8.57.0",
    "eslint-plugin-testing-library": "^6.2.2",
    "http-proxy-middleware": "^3.0.0",
    "fake-indexeddb": "^6.0.0",
    "husky": "^9.0.11",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jest-mock": "^29.7.0",
    "jose": "^5.6.3",
    "lint-staged": "^15.2.7",
    "ts-jest": "^29.2.2",
    "typedoc": "^0.26.4",
    "typescript": "~5.4.2",
    "yn": "^5.0.0"
  },
  "engines": {
    "node": ">=18"
  },
  "lint-staged": {
    "*.{js,jsx,ts,tsx}": "eslint --cache --fix"
  }
}
